// The header row: the selection and expansion control columns, every column header, then actions. The
// head carries the current density, which sets its cells' vertical padding.

import React from 'react'

import { useTable } from '../context'
import { HeaderCell } from './HeaderCell'

export const HeaderRow = () => {
  const { layout, slots, state, geometry } = useTable()
  const { HeaderCheckbox, ResizeBoundary } = slots
  const compact = state.view && state.view.density === 'compact'
  const sideOf = key => (geometry?.lockSide ? geometry.lockSide(key) : null)
  const { columns } = layout
  // A column's resize hit target is centred on its trailing edge, its second half (the lead) in the next
  // header cell (ResizeBoundary.js). The next cell carries it only while the two sit side by
  // side however the table scrolls: both scroll, or both lock to the same edge (the actions column locks to
  // the end edge while the table locks). Without that neighbour the whole target stays inside the column.
  const leadBefore = (index, side) => {
    const previous = index > 0 ? columns[index - 1] : null
    return previous && sideOf(previous.key) === side ? previous : null
  }
  const leads = columns.map((column, index) =>
    leadBefore(index, sideOf(column.key))
  )
  const actionsLead = layout.hasActions
    ? leadBefore(columns.length, geometry?.locking ? 'end' : null)
    : null
  const leadAfter = index =>
    index + 1 < columns.length ? leads[index + 1] : actionsLead
  return (
    <thead className={`me-table-head${compact ? ' is-compact' : ''}`}>
      <tr>
        {layout.selectable && <HeaderCheckbox />}
        {layout.expandable && (
          <th className="me-table-control" scope="col">
            <span className="sr-only">Details</span>
          </th>
        )}
        {columns.map((column, index) => (
          <HeaderCell
            key={column.key}
            column={column}
            lockStyle={geometry?.lockStyle?.(column.key)}
            edges={geometry?.lockEdges?.(column.key)}
            lead={leads[index]}
            grabInside={!leadAfter(index)}
          />
        ))}
        {layout.hasActions && (
          <th className="me-table-actions" scope="col">
            <span className="sr-only">Actions</span>
            {actionsLead && ResizeBoundary && (
              <ResizeBoundary column={actionsLead} lead />
            )}
          </th>
        )}
      </tr>
    </thead>
  )
}
